module.exports = __webpack_public_path__ + "img/weather.338c83c9.svg";